import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Gift, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { useNoIndex } from "@/lib/useNoIndex";
import { t } from "@/lib/i18n";
import Home from "@/pages/Home";
import { Button } from "@/components/ui/button";

export default function FreeLinkPage() {
  useNoIndex();
  const { token } = useParams();
  const [state, setState] = useState(null); // {status, expires_at}
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get(`/free/${token}`)
      .then(({ data }) => setState(data))
      .catch(() => setState({ status: "invalid" }))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="min-h-screen grid place-items-center text-[#7A6B63]">{t("common.loading")}</div>;

  if (state?.status === "unused") {
    return <Home freeToken={token} freeExpiry={state.expires_at} />;
  }

  const messages = {
    used: t("free.used"),
    expired: t("free.expired"),
    invalid: t("free.invalid"),
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] grid place-items-center px-4 py-12" data-testid="free-link-unavailable">
      <div className="max-w-md w-full text-center">
        <div className="flex items-center justify-center gap-2 text-[#C86D51] mb-6">
          <Gift className="w-6 h-6" />
          <span className="text-sm font-semibold tracking-wide uppercase">Portwrite</span>
        </div>
        <div className="rounded-3xl border border-[#E8DEC2] bg-white p-8 shadow-sm">
          <div className="w-12 h-12 rounded-full bg-[#F8EBE6] grid place-items-center mx-auto">
            <AlertTriangle className="w-6 h-6 text-[#B35A3E]" />
          </div>
          <h1 className="mt-4 font-serif text-2xl text-[#2C221E]" data-testid="free-link-status">
            {messages[state?.status] || messages.invalid}
          </h1>
          <p className="mt-2 text-sm text-[#7A6B63]">
            {t("free.stillCreate")}
          </p>
          <Link to="/">
            <Button className="mt-6 h-12 px-6 bg-[#C86D51] hover:bg-[#B35A3E] text-white rounded-xl" data-testid="start-normal-collection">
              {t("free.startNormal")}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
